<!--
 * @Description: 切换语言
 * @Author: cooky
 * @Date: 2021-03-02 15:46:47
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-16 15:39:23
-->
<template>
  <div class="lang-switcher">
    <s-select
      class="select"
      v-model="currentLang"
    >
      <s-select-option
        v-for="(lang, index) in langList"
        :key="index"
        :value="lang['value']"
        v-show="lang.value !== currentLang"
      >
        {{ lang['label'] }}
      </s-select-option>
    </s-select>
  </div>
</template>
<script>
import langList from '@/config/lang'

export default {
  name: 'LangSwitch',
  data () {
    return {
      langList,
      currentLang: langList[0].value
    }
  },
  watch: {
    currentLang (lang) {
      this.changeLang(lang)
    }
  },
  mounted () {
    // this.currentLang = this.$store.state.lang ||  langList[0].value
    this.getLocaleLangAndStore()
  },
  methods: {
    getSupportLangs () {
      const locales = require.context('../../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
      const langs = locales.keys().map(item => {
        const matched = item.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
          return matched[1]
        }
      })
      return langs
    },
    getLocaleLangAndStore () {
      const supportLangs = this.getSupportLangs()
      const defaultLang = window.sessionStorage.lang || this.$store.getters.lang
      if (defaultLang && supportLangs.includes(defaultLang)) {
        this.currentLang = defaultLang
        this.changeLang(defaultLang)
      } else {
        const lang = (navigator.language || navigator.userLanguage).toLocaleLowerCase() // 常规浏览器语言和IE浏览器
        if (supportLangs.includes(lang)) {
          this.currentLang = lang
          this.changeLang(lang)
        } else {
          this.currentLang = process.env.VUE_APP_I18N_FALLBACK_LOCALE
          this.changeLang(process.env.VUE_APP_I18N_FALLBACK_LOCALE)
        }
      }
    },
    changeLang (lang) {
      this.$i18n.locale = lang
      this.$store.commit('CHANGE_LANG', lang)
    }
  }
}
</script>
<style lang="less" scoped>
    .lang-switcher {
      display: inline-block;
      width: 114px;
      height: 38px;
      color: #fffbea;
      font-size: 20px;
      .select {
        width: 114px;
        height: 38px;
        padding: 0 4px;
        border-radius: 38px;
        background-color: rgba(165, 154, 157, .4);
        border: none;
        /deep/ .main-select {
          position: relative;
          justify-content: flex-end;
          white-space: nowrap;
          padding: 0 16px 0 24px;
          .selected-text {
            transform: translateX(-50%);
            font-family: hgame_font_default;
            letter-spacing: 1px;
            color: #fffbea;
            font-size: 20px;
          }
          .arrow {
            border-top-color: #fffbea;
            border-width: 6px;
          }
        }

        /deep/ .options {
          width: 114px;
          border: none;
          overflow: hidden;
          margin-top: 5px;
          .s-select-option {
            height: 38px;
            padding: 0 26px;
            font-family: hgame_font_default;
            letter-spacing: 1px;
            justify-content: center;
            background-color: rgba(77, 58, 63, .85);
            color: #fffbea;
            border: 0;
            &.selected {
              background-color:#633b41;
            }
            &:hover {
              background-color: #633b41;
            }
          }
        }
      }
    }
    @media screen and (max-width: 750px) {
       .lang-switcher {
            width: 15.2rem;
            height: 6.2667rem;
            font-size: 2.9333rem;
            .select {
                width: 15.2rem;
                height: 6.2667rem;
                padding: 0 2.1333rem 0 2.9333rem;
                 /deep/ .main-select {
                     padding: 0 2.1333rem 0 2.9333rem;
                     justify-content: space-between;
                     .selected-text {
                         font-size: 2.9333rem;
                     }
                     .arrow {
                            border-width: 1.0667rem;
                        }
                 }
                /deep/ .options {
                    width: 14.8rem;
                    .s-select-option {
                        padding: 0 1.3333rem;
                        height: 6.2667rem;
                        font-size: 2.9333rem;
                        // padding: 0 2.1333rem 0 2.9333rem;
                        text-align: left;
                    }
                }
            }
       }
    }
</style>
